// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"89c0ddeb","109":"705f37f9","653":"cba28714","664":"c5e27659","900":"4c5c23cb"}[chunkId] + ".chunk.js";
};